import { render, staticRenderFns } from "./custWiteOff.vue?vue&type=template&id=487ec16b&"
import script from "./custWiteOff.vue?vue&type=script&lang=js&"
export * from "./custWiteOff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports